import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { createFeatureSelector, createSelector, Store } from '@ngrx/store';

import * as reducer from '../reducers/setting.reducer';
import { IAppState } from '../states/app.state';

export const settingFeatureSelector = createFeatureSelector<reducer.IState>(reducer.featureKey);

export const selectAppState = createSelector(settingFeatureSelector, (state) => state.appType);

export const selectButtonClickDelayMs = createSelector(settingFeatureSelector, (state) => state.buttonClickDelayMs);
export const selectValidToken = createSelector(settingFeatureSelector, (state) => state.validToken);
export const selectCustomerQuotes = createSelector(settingFeatureSelector, (state) => state.customerQuotes);

@Injectable({
  providedIn: 'root',
})
export class SettingSelectService {
  constructor(private _store$: Store<IAppState>) {}

  getAppState() {
    return this._store$.select(selectAppState);
  }

  getButtonClickDelayMs() {
    return this._store$.select(selectButtonClickDelayMs);
  }
  buttonClickDelayMsSignal() {
    return toSignal(this._store$.select(selectButtonClickDelayMs), {
      initialValue: 0,
    });
  }

  validToken() {
    return this._store$.select(selectValidToken);
  }
  validTokenSignal() {
    return toSignal(this.validToken(), {
      initialValue: false,
    });
  }

  getCustomerQuotes() {
    return this._store$.select(selectCustomerQuotes);
  }
  customerQuotesSignal() {
    return toSignal(this.getCustomerQuotes(), {
      initialValue: [],
    });
  }
}
